module.exports = __webpack_public_path__ + "img/04.faf29ecd.jpg";